import UI from './UI';
import Dom from '../Dom';

export {
  ColorsPreset,
  FontsPreset,
} from './presets';

/**
 * @returns UI
 */
export const createInstance = () => new UI(Dom);

const instance = new UI(Dom);

export default instance;



// WEBPACK FOOTER //
// ./src/UI/index.js